import type { FieldCondition } from "./types";

/**
 * Evaluate a FieldCondition against form values.
 * Used for dependsOn filtering in useFieldResolver.
 */
export function evaluateCondition(
	condition: FieldCondition,
	formValues: Record<string, unknown>,
): boolean {
	const fieldValue = formValues[condition.fieldId];

	switch (condition.operator) {
		case "equals":
			return fieldValue === condition.value;
		case "not_equals":
			return fieldValue !== condition.value;
		case "in":
			return (
				Array.isArray(condition.value) && condition.value.includes(fieldValue)
			);
		case "not_in":
			return (
				Array.isArray(condition.value) && !condition.value.includes(fieldValue)
			);
		case "gte":
			return (
				typeof fieldValue === "number" &&
				fieldValue >= (condition.value as number)
			);
		case "lte":
			return (
				typeof fieldValue === "number" &&
				fieldValue <= (condition.value as number)
			);
		case "exists":
			return (
				fieldValue !== undefined && fieldValue !== null && fieldValue !== ""
			);
		case "not_exists":
			return (
				fieldValue === undefined || fieldValue === null || fieldValue === ""
			);
		default:
			return true;
	}
}
